import * as _ from 'lodash'
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as AsyncLock from 'async-lock';
import {WB_MetricViewMetricRow, WB_MetricViewRow} from "../PA.Core/PAdbSchemaRows";
import {esWB_Metric_View, esWB_Metric_View_Metric} from "../PA.Core/PAdbSchema";
import {ILease} from "../PA.Utils/PA.UtilsIF";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {GenericLease} from '../PA.Utils/GenericLease';


export class MetricViewService {

    private static dctMetricViewByWBID: { [id: number]: WB_MetricViewRow } = {};
    private static dctMetricViewByID: { [id: string]: WB_MetricViewRow } = {};
    private static dctMetricDefinitionByMetricViewWbID: { [id: number]: WB_MetricViewMetricRow[] } = {};
    private static dctMetricViews:WB_MetricViewRow[]  = [];

    private static _dbContext: PAdbContext;

    private static dctLock: any = new AsyncLock();
    private static dctMetricDefinitionLock: any = new AsyncLock();


    private static bIsLoaded: boolean = false;
    private static _lease: ILease;

    static getMetricViewByWBID(MetricViewWBID: number): Promise<WB_MetricViewRow> {

        return new Promise<WB_MetricViewRow>((resolve, error) => {

            MetricViewService.dctLock.acquire('global',
                (done: any) => {

                    MetricViewService.checkLease()
                        .then((ignore) => {
                            if (MetricViewWBID in MetricViewService.dctMetricViewByWBID) {
                                done(null, MetricViewService.dctMetricViewByWBID[MetricViewWBID]);
                                resolve(MetricViewService.dctMetricViewByWBID[MetricViewWBID]);
                                return;
                            } else if (MetricViewService.bIsLoaded && !(MetricViewWBID in MetricViewService.dctMetricViewByWBID)) {
                                done(null, MetricViewService.dctMetricViewByWBID[MetricViewWBID]);
                                resolve(undefined);
                                return;
                            }

                            MetricViewService.loadFromDB()
                                .then((res) => {
                                    done(null, MetricViewService.dctMetricViewByWBID[MetricViewWBID]);
                                    return MetricViewService.dctMetricViewByWBID[MetricViewWBID];
                                })
                                .then((targetType) => {
                                    resolve(targetType);
                                })
                                .catch((err2) => {
                                    error(err2);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })
                }
            )
        })
    }

    static async getMetricViewsByWBID(MetricViewWBIDs: number[]): Promise<WB_MetricViewRow[]> {
        let retVal: WB_MetricViewRow[] = [];
        let MetricView: WB_MetricViewRow;

        for (let aWbID of MetricViewWBIDs) {
            MetricView = await MetricViewService.getMetricViewByWBID(aWbID);
            if (!_.isUndefined(MetricView)) {
                retVal.push(MetricView);
            }
        }

        return retVal;
    }

    static async getMetricViews(): Promise<WB_MetricViewRow[]> {
        return new Promise<WB_MetricViewRow[]>((resolve, error) => {

            MetricViewService.dctLock.acquire('global',
                (done: any) => {

                    MetricViewService.checkLease()
                        .then((ignore) => {
                            if (MetricViewService.bIsLoaded ) {
                                done(null, MetricViewService.dctMetricViews);
                                resolve(undefined);
                                return;
                            }

                            MetricViewService.loadFromDB()
                                .then((res) => {
                                    done(null, MetricViewService.dctMetricViews);
                                    return MetricViewService.dctMetricViews
                                })
                                .then((targetType) => {
                                    resolve(targetType);
                                })
                                .catch((err2) => {
                                    error(err2);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })
                }
            )
        })

    }

    static getMetricViewByMetricViewID(MetricViewID: string): Promise<WB_MetricViewRow> {

        return new Promise<WB_MetricViewRow>((resolve, error) => {

            MetricViewService.dctLock.acquire('global',
                (done: any) => {

                    MetricViewService.checkLease()
                        .then((ignore) => {
                            if (MetricViewID in MetricViewService.dctMetricViewByID) {
                                done(null, MetricViewService.dctMetricViewByID[MetricViewID]);
                                resolve(MetricViewService.dctMetricViewByID[MetricViewID]);
                                return;
                            } else if (MetricViewService.bIsLoaded && !(MetricViewID in MetricViewService.dctMetricViewByID)) {
                                done(null, MetricViewService.dctMetricViewByID[MetricViewID]);
                                resolve(undefined);
                                return;
                            }

                            MetricViewService.loadFromDB()
                                .then((res) => {
                                    done(null, MetricViewService.dctMetricViewByID[MetricViewID]);
                                    return MetricViewService.dctMetricViewByID[MetricViewID];
                                })
                                .then((targetType) => {
                                    resolve(targetType);
                                })
                                .catch((err2) => {
                                    error(err2);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })
                }
            )

        })
    }

    static getMetricDefinitionByMetricViewWbID(wbMetricViewID: number) : Promise<WB_MetricViewMetricRow[]> {
        return new Promise<WB_MetricViewMetricRow[]>((resolve, error) => {
            MetricViewService.dctMetricDefinitionLock.acquire('global',
                (done: any) => {
                    MetricViewService.checkLease()
                        .then((ignore) => {
                            if (wbMetricViewID in MetricViewService.dctMetricDefinitionByMetricViewWbID) {
                                done(null, MetricViewService.dctMetricDefinitionByMetricViewWbID[wbMetricViewID]);
                                resolve(MetricViewService.dctMetricDefinitionByMetricViewWbID[wbMetricViewID]);
                                return;
                            } else if (MetricViewService.bIsLoaded && !(wbMetricViewID in MetricViewService.dctMetricDefinitionByMetricViewWbID)) {
                                done(null, MetricViewService.dctMetricDefinitionByMetricViewWbID[wbMetricViewID]);
                                resolve(undefined);
                                return;
                            }

                            MetricViewService.loadFromDB()
                                .then((ignore) => {
                                    done(null, MetricViewService.dctMetricDefinitionByMetricViewWbID[wbMetricViewID]);
                                    resolve(MetricViewService.dctMetricDefinitionByMetricViewWbID[wbMetricViewID]);
                                    return;
                                })
                                .catch((err) => {
                                    error(err);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })
                })
        })
    }



    private static loadFromDB(): Promise<void> {

        return new Promise<void>((resolve, error) => {

            MetricViewService.bIsLoaded = false;

            if (_.isUndefined(MetricViewService._dbContext)) {
                MetricViewService.instantiateDbContext();
            }

            MetricViewService._dbContext.findAll(esWB_Metric_View, {})
                .then((results) => {
                    if (_.isArray(results)) {
                        let MetricViews: WB_MetricViewRow[] = results as WB_MetricViewRow[];

                        MetricViewService.dctMetricViewByWBID = _.keyBy(MetricViews, (aMetricView) => aMetricView.cif.WB_MTRVIEW_ID);
                        MetricViewService.dctMetricViewByID = _.keyBy(MetricViews, (aMetricView) => aMetricView.cif.METRIC_VIEW_ID);
                        MetricViewService.dctMetricViews = MetricViews
                        MetricViewService._dbContext.findAll(esWB_Metric_View_Metric, {})
                            .then((rels:any) => {
                                if (_.isArray(rels)) {
                                    let MetricViewRels: WB_MetricViewMetricRow[] = rels as WB_MetricViewMetricRow[];

                                    _.forEach(MetricViewRels, (aRel) => {
                                        if (!_.isUndefined(MetricViewService.dctMetricViewByWBID[aRel.cif.WB_MTRVIEW_ID])) {
                                            if (_.isUndefined(MetricViewService.dctMetricDefinitionByMetricViewWbID[aRel.cif.WB_MTRVIEW_ID])) {
                                                MetricViewService.dctMetricDefinitionByMetricViewWbID[aRel.cif.WB_MTRVIEW_ID] = [];
                                            }
                                            MetricViewService.dctMetricDefinitionByMetricViewWbID[aRel.cif.WB_MTRVIEW_ID].push(aRel);
                                        }

                                    });

                                    MetricViewService.bIsLoaded = true;
                                    resolve();
                                }
                            })
                            .catch((err) => {
                                error(err);
                            });
                    } else {
                        error("Unrecognized MetricView Search Results")
                    }
                })
                .catch((err) => {
                    error(err);
                });
        });
    }


    private static createLease() {
        MetricViewService._lease = new GenericLease(LeaseRegistry.Lease_Type_MetricView);
    }

    private static async checkLease(): Promise<void> {
        if (_.isUndefined(MetricViewService._lease)) {
            MetricViewService.createLease();
        }

        if (await MetricViewService._lease.hasDataChanged()) {
            await MetricViewService.reset();
            MetricViewService._lease.resetLease();
        }
    }

    private static async reset(): Promise<void> {

        MetricViewService.instantiateDbContext();

        let arr: WB_MetricViewRow[] = _.values(MetricViewService.dctMetricViewByWBID);
        await MetricViewService._dbContext.purgeCache(esWB_Metric_View, arr);

        MetricViewService.dctMetricDefinitionByMetricViewWbID = {};

        MetricViewService.dctMetricViewByWBID = {};
        MetricViewService.dctMetricViewByID = {};

        MetricViewService.bIsLoaded = false;
    }

    private static instantiateDbContext() {
        MetricViewService._dbContext = new PAdbContext();
    }


    static getLeaseClasses(viewWbID: number) : string[] {
        let retVal: string[] = [];
        retVal.push(LeaseRegistry.getLeaseClass(LeaseRegistry.Lease_Type_MetricView, viewWbID));
        return retVal;
    }

}
